import api from '@/services/api';

const searchBySiret = (siret) => api()
  .get(`sirene/siret/${siret}`);

const searchByCompanyName = (name) => api()
  .get(`sirene/autocomplete?query=${name}`);

export {
  searchByCompanyName,
  searchBySiret,
};
